
<div class="row d-flex justify-content-center position-relative">

  <div class="load" *ngIf="loadInfo">
    <app-spinner [loading]="loadInfo" [text]="'LOADING' | translate"></app-spinner>
  </div>

  <div class="col-md-12" [ngClass]="{ 'bg-blur': loadInfo}" >
    <!-- {{ error | json }} -->
    <!-- {{'PASSWORD' | translate}} -->
      

      <form [formGroup]="form"  (ngSubmit)="changeInfo()">
        <div class="row">

          <div class="col-12 mt-3">
            <div class="form-floating">
              <input 
                type="text" 
                [ngClass]="{'is-invalid': error?.error}"
                class="form-control" 
                formControlName="name"  
                placeholder="{{ 'NAME' | translate }}">
              <label for="name">{{ 'NAME' | translate }}</label>
            </div>
          </div>

          <div class="col-12 mt-3">
            <div class="form-floating">
              <input 
                type="text" 
                [ngClass]="{'is-invalid': error?.error}"
                class="form-control" 
                formControlName="lastname"  
                placeholder="{{ 'LASTNAME' | translate }}">
              <label for="lastname">{{ 'LASTNAME' | translate }}</label>
            </div>
          </div>

          <!-- <div class="col-12 mt-3">
              <div class="d-flex align-items-center p-0 mb-3">
                  <div class="form-floating flex-shrink-1">
                      <select 
                          style="background-image: none !important;"
                          class="index-select form-control border-index" 
                          [ngClass]="{
                            'is-invalid': error?.phone || data?.phone_verify == 0,
                            'is-valid': data?.phone_verify == 1
                          }"
                          formControlName="index" 
                          (mousedown)="showFullIndex = true" 
                          (mouseup)="showFullIndex = true" 
                          (change)="onIndexChange($event)" 
                          (blur)="showFullIndex = false">
                          <option class="index-font" *ngFor="let item of indexPhone" [value]="item.index">
                                  {{ showFullIndex ? (item.name + ' ' + item.index) : item.index }}
                          </option>
                      </select>
                      <label for="floatingPhoneIndex">{{ 'INDEX' | translate }}</label>
                  </div>
              
                  <div class="form-floating flex-grow-1 border-radius-left-none phone">
                  <input 
                      type="text" 
                      [ngClass]="{
                        'is-invalid': error?.phone || data?.phone_verify == 0,
                        'is-valid': data?.phone_verify == 1
                      }"
                      class="form-control form-control-b border-phone" 
                      formControlName="phone"
                      id="floatingInputphone" 
                      placeholder="{{ 'PHONE' | translate }}">
                  <label for="floatingInputphone">{{ 'PHONE' | translate }}</label>
                  </div>
              </div>
          
          </div> -->

          <div class="col-12  mt-3">
            {{data?.verify_email}}
              <div class="form-floating">
                  <input
                      type="email"
                      [ngClass]="{
                        'is-invalid': error?.email || data?.email_verify == 0,
                        'is-valid': data?.email_verify == 1
                      }"
                      id="email"
                      class="form-control"
                      formControlName="email"
                      placeholder="{{ 'EMAIL' | translate }}">
                  <label for="email">{{ 'EMAIL' | translate }}</label>
                  <div class="invalid-feedback">
                      {{ error?.email }}
                  </div>
              </div>
          </div>
          <div class="col-12 mb-3">
            <app-seand *ngIf="data?.email_verify == 0" [email]="data.email"></app-seand>
          </div>
      </div>

    

      <button type="submit" class="btn btn-lg btn-primary mb-3" [disabled]="loadSave || form.invalid">
        <span *ngIf="loadSave" class="spinner-border spinner-border-sm" role="status" ></span>
        {{ 'CHANGE' | translate }}
      </button>
    </form>
  </div>
</div>
